import { render, staticRenderFns } from "./CardPayment.vue?vue&type=template&id=1373583b&scoped=true"
import script from "./CardPayment.vue?vue&type=script&lang=ts"
export * from "./CardPayment.vue?vue&type=script&lang=ts"
import style0 from "./CardPayment.vue?vue&type=style&index=0&id=1373583b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373583b",
  null
  
)

export default component.exports